const color = [
  "primary",
  "secondary",
  "success",
  "info",
  "warning",
  "error",
  "neutral"
] as const

export default {
  "slots": {
    "root": "tw:relative tw:group tw:overflow-hidden tw:bg-default tw:shadow-lg tw:rounded-lg tw:ring tw:ring-default tw:p-4 tw:flex tw:gap-2.5 tw:focus:outline-none",
    "wrapper": "tw:w-0 tw:flex-1 tw:flex tw:flex-col",
    "title": "tw:text-sm tw:font-medium tw:text-highlighted",
    "description": "tw:text-sm tw:text-muted",
    "icon": "tw:shrink-0 tw:size-5",
    "avatar": "tw:shrink-0",
    "avatarSize": "2xl",
    "actions": "tw:flex tw:gap-1.5 tw:shrink-0",
    "progress": "tw:absolute tw:inset-x-0 tw:bottom-0",
    "close": "tw:p-0"
  },
  "variants": {
    "color": {
      "primary": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-primary",
        "icon": "tw:text-primary"
      },
      "secondary": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-secondary",
        "icon": "tw:text-secondary"
      },
      "success": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-success",
        "icon": "tw:text-success"
      },
      "info": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-info",
        "icon": "tw:text-info"
      },
      "warning": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-warning",
        "icon": "tw:text-warning"
      },
      "error": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-error",
        "icon": "tw:text-error"
      },
      "neutral": {
        "root": "tw:focus-visible:ring-2 tw:focus-visible:ring-inset tw:focus-visible:ring-inverted",
        "icon": "tw:text-highlighted"
      }
    },
    "orientation": {
      "horizontal": {
        "root": "tw:items-center",
        "actions": "tw:items-center"
      },
      "vertical": {
        "root": "tw:items-start",
        "actions": "tw:items-start tw:mt-2.5"
      }
    },
    "title": {
      "true": {
        "description": "tw:mt-1"
      }
    }
  },
  "defaultVariants": {
    "color": "primary" as typeof color[number]
  }
}